<template>
  <div
    class="bc-report-business-table"
    :class="{'credit-business-table': isCreditExam}"
  >
    <pagination-table
      title="工商信息"
      :show-header="false"
      :table-data="business.entities"
      :table-props="business.props"
      :loading="business.loading"
      :table-span-method="tableSpanMethod"
      :show-total="false"
      :border="!isCreditExam"
      :stripe="!isCreditExam"
      :is-credit-exam="isCreditExam"
    />
  </div>
</template>

<script>
import PaginationTable from '@/components/table/PaginationTable'
import lawExamService from '@/service/law-exam'
import { mapState } from 'vuex'
import dayjs from 'dayjs'
export default {
  name: 'BcReportBusinessTable',
  components: { PaginationTable },
  props: {
    isCreditExam: Boolean,
    companyId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      business: {
        props: [
          { label: 'key1', prop: 'key1', className: this.isCreditExam ? 'table-credit-row' : 'table-highlight-row', width: 150 },
          { label: 'value1', prop: 'value1' },
          { label: 'key2', prop: 'key2', className: this.isCreditExam ? 'table-credit-row' : 'table-highlight-row', width: 150 },
          { label: 'value2', prop: 'value2' }
        ],
        entities: [],
        loading: false
      }
    }
  },
  mounted () {
    this.getBusiness()
  },
  methods: {
    getBusiness () {
      this.business.loading = true
      if (!this.isCreditExam) {
        let params = { companyId: this.companyId }
        lawExamService.reportRequestBaseInfo('businessInformation', params).then(res => {
          this.business.loading = false
          this.parseData(res.data)
        })
      }
    },
    parseData (data) {
      let values = [
        { key1: '统一社会信用代码', prop1: 'creditCode', key2: '组织机构代码', prop2: 'orgNumber' },
        { key1: '注册号', prop1: 'regNumber', key2: '经营状态', prop2: 'regStatus' },
        { key1: '所属行业', prop1: 'industry', key2: '成立日期', prop2: 'estiblishTime' },
        { key1: '公司类型', prop1: 'companyOrgType', key2: '营业期限', prop2: 'duration' },
        { key1: '法定代表人', prop1: 'legalPersonName', key2: '核准日期', prop2: 'approvedTime' },
        { key1: '注册资本', prop1: 'regCapital', key2: '登记机关', prop2: 'regInstitute' },
        { key1: '注册地址', prop1: 'regLocation' },
        { key1: '经营范围', prop1: 'businessScope' }
      ]
      if (data.approvedTime) {
        data.approvedTime = dayjs(data.approvedTime).format('YYYY-MM-DD')
      }
      if (data.estiblishTime) {
        let estiblishTime = parseInt(data.estiblishTime)
        data.estiblishTime = dayjs(estiblishTime).format('YYYY-MM-DD')
      }
      if (!data.fromTime && !data.toTime) {
        data.duration = '-'
      } else {
        data.duration = data.fromTime ? dayjs(data.fromTime).format('YYYY-MM-DD') : '-'
        data.duration = (data.duration || '') + '至' + (data.toTime ? dayjs(data.toTime).format('YYYY-MM-DD') : '无固定日期')
      }
      values.forEach(item => {
        item.value1 = data[item.prop1]
        if (item.prop2) item.value2 = data[item.prop2]
        if (item.prop2 === 'regStatus' && ['吊销', '注销'].includes(item.value2)) {
          item.className = 'table-red-cell'
          item.classLabel = 'value2'
        }
        if (this.isCreditExam) {
          item.key1 = item.key1 + '：'
          if (item.key2) item.key2 = item.key2 + '：'
        }
      })
      this.business = Object.assign({}, this.business, {
        entities: values,
        loading: false
      })
    },
    tableSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (rowIndex >= 6) {
        if (columnIndex === 1) {
          return [1, 3]
        }
      }
    }
  }
}
</script>

<style lang="stylus">
.credit-business-table
  .el-table td
    border-bottom-color transparent
  .table-credit-row
    color #9B9B9B
  .table-column
    font-size 14px
  .el-table::before
    height 0
</style>
